<template>
	<v-card>
		<v-card-title>烘焙方案修改</v-card-title>
		<v-card-text>
			<v-alert v-if="updateHint" type="info" density="compact" variant="tonal" class="mb-3">
				{{ updateHint }}
			</v-alert>
			<div class="d-flex flex-row align-center">
				{{ bean.name }}
			</div>
			<div class="d-flex flex-row align-center">
				<v-text-field type="number" v-model.number="form.beanqty" style="max-width: 12rem" class="mr-2">
					<template #prepend>入豆量</template>
					<template #append-inner>克</template>
				</v-text-field>

				<v-text-field type="number" v-model.number="form.starttemp" style="max-width: 10rem" class="mr-2">
					<template #prepend>入豆温</template>
					<template #append-inner>
						<iconify-icon icon="mdi:temperature-celsius" style="font-size: 1.2rem"></iconify-icon>
					</template>
				</v-text-field>
			</div>
			<div class="d-flex flex-row align-center">
				<div stylxe="height: auto" class="d-block align-center">转黄：</div>
				<TimeInput v-model="form.yellowtime" />
				<v-text-field
					class="ml-4"
					type="number"
					variant="solo"
					v-model.number="form.yellowtemp"
					style="width: 6rem; max-width: 6rem"
				>
					<template #append-inner>
						<iconify-icon icon="mdi:temperature-celsius" style="font-size: 1.2rem"></iconify-icon>
					</template>
				</v-text-field>
			</div>
			<div class="d-flex flex-row align-center">
				一爆：
				<TimeInput v-model="form.fctime" />

				<v-text-field
					class="ml-4"
					type="number"
					variant="solo"
					v-model.number="form.fctemp"
					style="width: 6rem; max-width: 6rem"
				>
					<template #append-inner>
						<iconify-icon icon="mdi:temperature-celsius" style="font-size: 1.2rem"></iconify-icon>
					</template>
				</v-text-field>
			</div>
			<div class="d-flex flex-row align-center">
				二爆：
				<TimeInput v-model="form.sctime" />

				<v-text-field
					class="ml-4"
					type="number"
					variant="solo"
					v-model.number="form.sctemp"
					style="width: 6rem; max-width: 6rem"
				>
					<template #append-inner>
						<iconify-icon icon="mdi:temperature-celsius" style="font-size: 1.2rem"></iconify-icon>
					</template>
				</v-text-field>
			</div>
			<div class="d-flex flex-row align-center">
				总时间：
				<TimeInput v-model="form.totaltime" />

				<template v-if="form.totaltime && form.fctime">
					DTR：
					{{ dtr }}%
				</template>
			</div>
			<div class="d-flex flex-row align-center">
				烘焙度：
				<v-radio-group v-model="form.degree" inline>
					<v-radio v-for="degree in refs.RoastDegree" :key="degree.value" :value="degree.value">
						<template #label>
							<roast-degree-badge
								:degree="degree.value"
								:label-override="degree.title"
								:color-override="degree.color"
							/>
						</template>
					</v-radio>
				</v-radio-group>
				<v-alert type="error" density="compact" v-if="errors.degree">{{ errors.degree }}</v-alert>
			</div>
			<div class="d-flex flex-row align-center">
				<v-text-field
					v-model.number="form.agtron"
					type="number"
					label="豆色值 Agtron"
					style="max-width: 10rem"
				></v-text-field>
				<v-text-field
					class="ml-4"
					v-model.number="form.agtron_ground"
					type="number"
					label="粉色值 Agtron"
					style="max-width: 10rem"
				></v-text-field>
				<v-text-field
					class="ml-4"
					type="number"
					label="失重率"
					variantxx="solo"
					v-model.number="form.lossrate"
					style="width: 6rem; max-width: 6rem"
				>
					<template #append-inner>%</template>
				</v-text-field>
			</div>
			<v-textarea v-model="form.description" label="备注" rows="2" auto-grow variant="outlined" />
			<v-expansion-panels class="mt-4" variant="accordion">
				<v-expansion-panel title="参数允许范围（可选，留空保存时按标称值自动计算）">
					<v-expansion-panel-text>
						<div class="text-caption mb-2">下限 ~ 上限；仅填写一侧时另一侧仍会按标称值补全</div>
						<div v-for="row in boundRows" :key="row.key" class="d-flex flex-row align-center mb-2 flex-wrap">
							<span class="mr-2" style="min-width: 5rem">{{ row.label }}</span>
							<v-text-field
								v-model.number="form[row.lower]"
								type="number"
								density="compact"
								hide-details
								label="下限"
								style="max-width: 7rem"
							/>
							<span class="mx-1">~</span>
							<v-text-field
								v-model.number="form[row.upper]"
								type="number"
								density="compact"
								hide-details
								label="上限"
								style="max-width: 7rem"
							/>
							<span v-if="row.unit" class="ml-1 text-caption">{{ row.unit }}</span>
						</div>
					</v-expansion-panel-text>
				</v-expansion-panel>
			</v-expansion-panels>
		</v-card-text>
		<v-card-actions class="justify-center">
			<slot name="actions" :object="form"></slot>
		</v-card-actions>
	</v-card>
</template>

<script>
import TimeInput from './TimeInput.vue'
import RoastDegreeBadge from './DegreeBadge.vue'
import { clone } from 'lodash-es'

export default {
	components: {
		TimeInput,
		RoastDegreeBadge
	},
	props: {
		value: { type: Object, default: () => ({}) },
		errors: { type: Object, default: () => ({}) },
		updateHint: { type: String, default: '' }
	},
	data() {
		return {
			form: {
				starttemp: 0,
				yellowtemp: 0,
				yellowtime: 0,
				fctemp: 0,
				fctime: 0,
				sctemp: 0,
				sctime: 0,
				totaltime: null,
				//结果
				agtron: '',
				agtron_ground: '',
				description: '',
				lossrate: 0,
				degree: '',
				roaster: '',
				machine: ''
			},
			yellowMin: 0,
			yellowSec: 0,
			fctimeMin: 0,
			fctimeSec: 0,
			sctimeMin: 0,
			sctimeSec: 0,
			profile: {},
			bean: {},
			refs: {}
		}
	},
	mounted() {
		this.$api.common.meta('roast', `RoastDegree`, (res) => {
			this.refs = res
		})
		this.load()
	},
	computed: {
		boundRows() {
			return [
				{ key: 'starttemp', label: '入豆温', lower: 'starttemp_lower', upper: 'starttemp_upper', unit: '°C' },
				{ key: 'tptemp', label: '回温', lower: 'tptemp_lower', upper: 'tptemp_upper', unit: '°C' },
				{ key: 'tptime', label: '回温时间', lower: 'tptime_lower', upper: 'tptime_upper', unit: '秒' },
				{ key: 'yellowtemp', label: '转黄温', lower: 'yellowtemp_lower', upper: 'yellowtemp_upper', unit: '°C' },
				{ key: 'yellowtime', label: '转黄时间', lower: 'yellowtime_lower', upper: 'yellowtime_upper', unit: '秒' },
				{ key: 'fctemp', label: '一爆温', lower: 'fctemp_lower', upper: 'fctemp_upper', unit: '°C' },
				{ key: 'fctime', label: '一爆时间', lower: 'fctime_lower', upper: 'fctime_upper', unit: '秒' },
				{ key: 'sctemp', label: '二爆温', lower: 'sctemp_lower', upper: 'sctemp_upper', unit: '°C' },
				{ key: 'sctime', label: '二爆时间', lower: 'sctime_lower', upper: 'sctime_upper', unit: '秒' },
				{ key: 'totaltime', label: '总时间', lower: 'totaltime_lower', upper: 'totaltime_upper', unit: '秒' },
				{ key: 'agtron', label: '豆色值', lower: 'agtron_lower', upper: 'agtron_upper', unit: '' },
				{
					key: 'agtron_ground',
					label: '粉色值',
					lower: 'agtron_ground_lower',
					upper: 'agtron_ground_upper',
					unit: ''
				},
				{ key: 'lossrate', label: '失重率', lower: 'lossrate_lower', upper: 'lossrate_upper', unit: '%' },
				{ key: 'beanqty', label: '入豆量', lower: 'beanqty_lower', upper: 'beanqty_upper', unit: '克' }
			]
		},
		dtr() {
			if (this.form.totaltime && this.form.fctime) {
				let a = ((this.form.totaltime - this.form.fctime) / this.form.totaltime) * 100
				if (a) return a.toFixed(2)
				return 0
			}
		}
	},
	watch: {
		value: {
			handler() {
				this.load()
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		load() {
			this.form = clone(this.value)
			this.loadBean()
			this.fromYellowTime()
		},
		toYellowTime() {
			this.form.yellowtime = this.yellowMin * 60 + this.yellowSec
		},
		fromYellowTime() {
			this.yellowMin = Math.floor(this.form.yellowtime / 60)
			this.yellowSec = this.form.yellowtime % 60
		},
		loadBean() {
			if (this.form && this.form.bean_id) {
				this.$api.bean.getById(this.form.bean_id, (res) => {
					this.bean = res
				})
			}
		}
	}
}
</script>
